<template>
  <div
    v-loading="loading"
    class="card"
  >
    <div class="card-body">
      <ui-quote>
        {{ $tc('Marketplaces', 1) }}: <b>{{ marketplace.title }}</b><br>
        <a
          href="#"
          @click.prevent="goBack('marketplaces', { name: 'Marketplaces' })"
        >
          <i class="fa fa-arrow-circle-left" /> {{ $t('Go back').toLowerCase() }}
        </a>
      </ui-quote>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link
            :to="{ name: 'MarketplaceMain' }"
            class="nav-link"
            replace
            exact
            @updated="load"
          >
            {{ $t('Main') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'MarketplaceCredentialFields' }"
            class="nav-link"
            replace
            exact
            @updated="load"
          >
            {{ $tc('Credential Fields', 2) }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'MarketplaceTemplates' }"
            class="nav-link"
            replace
            exact
            @updated="load"
          >
            {{ $tc('Templates', 2) }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'MarketplaceFields' }"
            class="nav-link"
            replace
            exact
            @updated="load"
          >
            {{ $tc('Fields', 2) }}
          </router-link>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane fade show active">
          <router-view @updated="load" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketplaceService from '../services/MarketplacesService';

export default {
  name: 'AppContainerMarketplace',
  data() {
    return {
      marketplace: {},
      loading: false,
    };
  },
  computed: {
    /**
       * Returns Marketplace ID value from route.
       * @returns {number} Marketplace ID from route
       */
    marketplaceId() {
      return parseInt(this.$route.params.marketplaceId, 10);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      MarketplaceService.findById(this.marketplaceId).then(marketplace => {
        this.marketplace = marketplace;
        this.loading = false;
      }).catch(() => {
        this.$errors_go404();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .tab-pane {
    min-height: 60vh;
  }
</style>
